// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Auth_form__XdW2d {
  max-width: 100%;
  width: 100%;
  text-align: left;
  border:0;
  border-radius: 0;
  padding: 0;
  background: #FFF;
}
  
.Auth_button__wLxLD {
    margin-top: 10px;
}







`, "",{"version":3,"sources":["webpack://./src/views/Authentication/Auth.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".form {\n  max-width: 100%;\n  width: 100%;\n  text-align: left;\n  border:0;\n  border-radius: 0;\n  padding: 0;\n  background: #FFF;\n}\n  \n.button {\n    margin-top: 10px;\n}\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `Auth_form__XdW2d`,
	"button": `Auth_button__wLxLD`
};
export default ___CSS_LOADER_EXPORT___;
